import axios from "axios";

export default {
    SubLevelGetById: async function(id, callback, errCallback) {
        await axios.get('/sub-levels/' + id, {}, {
            withCredentials: true
        })
        // .then(response => {console.log("ttt resp", response); return response;})
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! sub level", error);
            errCallback(error)
        });
    }
}
